import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { ConnectivityService } from '@core/services/connectivity.service';
import { SyncService } from '@core/services/sync.service';

@Component({
  selector: 'app-sync-status',
  imports: [CommonModule],
  templateUrl: './sync-status.component.html',
  styleUrl: './sync-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyncStatusComponent {
  private readonly connectivityService = inject(ConnectivityService);
  readonly syncService = inject(SyncService);
  readonly isTooltipVisible = signal(false);

  readonly isOnline = computed(() => this.connectivityService.online());
  readonly pendingCount = computed(() => this.syncService.pendingCount());
  readonly isSyncing = computed(() => this.syncService.isSyncing());
  readonly tooltip = computed(() => {
    if (!this.isOnline()) {
      const pending = this.pendingCount();
      return pending > 0
        ? `No hay internet. ${pending} cambio${pending === 1 ? '' : 's'} se sincronizar${pending === 1 ? 'a' : 'an'} más tarde.`
        : 'No hay internet. Se sincronizará más tarde.';
    }

    if (this.isSyncing()) {
      return 'En línea. Sincronizando cambios pendientes.';
    }

    return 'En línea. Todo sincronizado.';
  });

  showTooltip(): void {
    this.isTooltipVisible.set(true);
  }

  hideTooltip(): void {
    this.isTooltipVisible.set(false);
  }

  toggleTooltip(): void {
    this.isTooltipVisible.update((visible) => !visible);
  }
}
